var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTickIcon = function SvgTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "url(#TickIcon_svg__acn3sh0saa)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.025 13a.606.606 0 01-.445-.197l-2.396-2.565a.708.708 0 010-.952.6.6 0 01.89 0l1.95 2.09 3.903-4.179a.6.6 0 01.889 0 .708.708 0 010 .952l-4.347 4.654a.607.607 0 01-.444.197z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "TickIcon_svg__acn3sh0saa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.6019 12.44238 -12.94143 5.8266 4.398 5.558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgTickIcon;